export default __webpack_public_path__ + "static/deep-learning-leaders-nav-a181c2f57a4074e80b297a0638679c5d.avif";